module.exports = __webpack_public_path__ + "static/img/button_production_active.74594630.png";